import React from "react";
import { Page } from "../../components/page/page";
import styles from "./animals.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAnimals } from "../../store/stateSlice";

const options = [
  {
    value: "Yes, animals are often drawn to me",
    icon: "🤩",
  },
  {
    value: "I sometimes have special moments",
    icon: "😌",
  },
  {
    value: "I don't notice a unique connection",
    icon: "🙂",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const AnimalsPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Do animals seem unusually drawn to you or do you understand them on a deep level?"
      hideContinueButton={true}
      currentStep={7}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../elements"
              onClick={() => dispatch(setAnimals(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { AnimalsPage };
